
export class TechnicalShutdown {
	public id: string;
	public vehicle_id: string;
	public _from: Date;
	public to: Date;
	public prefix: string;
	public motivation: string;
	public closed_at: Date;

	constructor(server_obj: any) {
		this.prefix = 'tsh_';
		if (server_obj) {
			this.id          = server_obj[this.prefix + 'id'];
			this.vehicle_id   = server_obj[this.prefix + 'vehicle_id'];
			this._from   = new Date(server_obj[this.prefix + 'from']);
			this.to = server_obj[this.prefix + 'to'] ? new Date(server_obj[this.prefix + 'to']) : null;
			this.motivation   = server_obj[this.prefix + 'motivation'];
      this.closed_at = server_obj[this.prefix + 'closed_at'] ? new Date(server_obj[this.prefix + 'closed_at']) : null;
		} else {

		}
	}
}
